import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const LangContext = createContext({ lang: "no", toggle: () => {}, t: (obj) => obj });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("no");

  // setLang from useState has a stable identity (React guarantee).
  // The inner callback parameter `l` is NOT a closure variable, so no deps are needed.
  const toggle = useCallback(() => setLang((l) => (l === "no" ? "en" : "no")), []);

  // t() takes a {no, en} object and returns the current language string.
  const t = useCallback(
    (obj) => {
      if (obj == null) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] ?? obj.no ?? "";
    },
    [lang]
  );

  // Memoize provider value so consumers don't re-render when an unrelated parent re-renders.
  const value = useMemo(() => ({ lang, toggle, t }), [lang, toggle, t]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
